export enum UserTitle {
  FUNZIONARIO = 'FUNZIONARIO',
  ASSISTENTE = 'ASSISTENTE',
  OPERATORE = 'OPERATORE',
  ISPETTORE_SPECIALISTA = 'ISPETTORE SPECIALISTA',
  PROFESSIONISTA_I_QUAL_PROF = 'PROFESSIONISTA I QUAL. PROF.',
  PROFESSIONISTA_II_QUAL_PROF = 'PROFESSIONISTA II QUAL. PROF.',
}
